import React from 'react'
import styled from 'styled-components'
import IMAGES from 'src/commons/variables/images'
import { Col, Row, Image } from 'antd';
const HeaderWrapper = styled.div`
    padding: 10px;    
    position:absolute
`
export default function Header() {
    return (
        <HeaderWrapper>
            <Row  >
                <Col push={1} sm={7} xs={10} >
                    <Image preview={false} src={IMAGES.LOGO.default} />
                </Col>
            </Row>
        </HeaderWrapper>
    )
}
